/** Avoid running the same function twice within the specified timeframe. */
export const debounce = (
    func: Function,
    wait: number,
    immediate: boolean = false
) => {
    let timeout: any;
    return function () {
        var context = this,
            args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            timeout = null;
            if (!immediate) func.apply(context, args);
        }, wait);
        if (immediate && !timeout) func.apply(context, args);
    };
};
